import type { App as VueApp } from "vue";
import type { Router } from "vue-router";
import * as Sentry from "@sentry/vue";

import Config from "@/common/config";

export function setupSentry(app: VueApp, router: Router): void {
  const { dsn, env: environment } = Config.sentryConfig;

  if (!dsn) {
    return;
  }

  const isProduction = environment === "production";

  Sentry.init({
    app,
    dsn,
    environment,

    sendDefaultPii: true,

    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    replaysSessionSampleRate: isProduction ? 0.01 : 0.05,
    replaysOnErrorSampleRate: 1.0,

    enableLogs: true,
    tracesSampleRate: isProduction ? 0.01 : 0.05,

    tracePropagationTargets: createTracePropagationTargets(
      Config.apiEndpoints.baseURL,
      Config.apiEndpoints.etCoreURL,
    ),
  });
}

function createTracePropagationTargets(...urls: string[]): RegExp[] {
  const uniqueOrigins = new Set(
    urls.map((url) => new URL(url, window.location.origin).origin),
  );

  return [...uniqueOrigins].map(
    (origin) => new RegExp(`^${escapeRegExp(origin)}(?:/|$)`),
  );
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
